import { createApp as createVueApp } from 'vue'
import { createRouter, createMemoryHistory, createWebHistory } from 'vue-router'
import App from './App.vue'
import { createSiteRouter } from './router'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/server'
import AuthPlugin from './plugins/Auth'
// 导入基础组件插件
import ComponentsPlugin from './plugins/Components'
export async function createAppInstance(context = {}) {
  
  const isServer = typeof window === 'undefined'
  
  const routes = await createSiteRouter()

  const app = createVueApp(App)

  const router = createRouter({
    history: isServer ? createMemoryHistory() : createWebHistory(),
    routes
  })

  app.use(router)

  const pinia = createPinia()
  app.use(pinia)

  const head = createHead()
  app.use(head)
    // 注册全局组件
  app.use(ComponentsPlugin)
  // 在客户端环境中使用认证插件
  if (!isServer) {
    app.use(AuthPlugin)
  }

  return { app, router, head }
}